import { client } from "./index";

// Public store data: settings, banners and categories (/api/storefront)
export const getConfig = () => client.get("/storefront/config").then((res) => res.data);

export const getCategories = () => client.get("/storefront/categories").then((res) => res.data.categories);

// The store's blog (written in the admin panel's website editor -> Blog)
export const getBlogPosts = () => client.get("/storefront/blog").then((res) => res.data.posts);
export const getBlogPost = (slug) => client.get(`/storefront/blog/${encodeURIComponent(slug)}`).then((res) => res.data.post);
